import { Box, Stack, VStack } from 'components/Stack';
import Text from 'components/Text';
import { useResponsive } from 'hooks/useResponsive';
import { useTheme } from 'styled-components';
import { useReviews } from './review.hook';
import { useTranslation } from 'react-i18next';

const SectionE = ({ onClickBook }: { onClickBook?: () => void }) => {
  const theme = useTheme();
  const { isSmallScreen } = useResponsive();
  const reviews = useReviews();
  const { t } = useTranslation();

  return (
    <section className='sectionD'>
      <VStack className='container' $padding='0 1rem'>
        <Text
          color={theme.color.focus200}
          fontSize='1rem'
          fontWeight={700}
        >
          {t('카공24실이용자들의')}
        </Text>
        <Box $width='100%' $alignItems='flex-start'>
          <Text
            $lineHeight='2'
            fontWeight={600}
            as='h2'
            color={theme.color.secondary1000}
            fontSize={isSmallScreen ? '1.6rem' : '2rem'}
          >
            {t('이용후기')}
          </Text>
        </Box>
        <Stack $gap='0.5rem'>
          {reviews.map(({ review, username }) => {
            return (
              <Box
                $flex={1}
                $width='100%'
                key={review}
                $padding='1rem 1rem'
              >
                <Text>{username}</Text>
                <Text>{`"${review}"`}</Text>
              </Box>
            );
          })}
        </Stack>
      </VStack>
    </section>
  );
};

export default SectionE;
